import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { useData } from "../../DataContext";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import * as moment from 'moment';
import i18n from '../../i18n'
import "moment/locale/zh-hk";
import "moment/locale/zh-cn";
import MomentUtils from "@date-io/moment";
import { TimePicker } from 'antd';
import { Helmet } from "react-helmet";
import {
    FormControlLabel,
    FormLabel,
    FormGroup,
    FormControl,
    Button,
    Box,
    Checkbox,
    InputLabel,
    FormHelperText,
    TextField
} from '@material-ui/core';
import InputMask from 'react-input-mask';
import {
    MuiPickersUtilsProvider
  } from "@material-ui/pickers";

import 'antd/dist/antd.css'
import './DateTimeDetail.scss'

import ScheduleOutlinedIcon from '@material-ui/icons/ScheduleOutlined';

import {
    Navbar,
    Header,
    StepHeader,
    FormBox,
    DatePicker,
    Footer
} from '../../components/_index'
import { date } from 'yup/lib/locale';
import ErrorsContainer from '../../components/ErrorsContainer/ErrorsContainer';
import { useYupValidationResolver } from '../../YupValidationResolver';
// import { boolean } from 'yup/lib/locale';
// import { date, string } from 'yup/lib/locale';
import Scroll from 'react-scroll';
import { checkIfRedirect, dateMask, isEmpty, isObjectEmpty, timeMask } from '../../utils';
import errorWarning from '../../images/icon_warning.gif'

export default withTranslation()(function DateTimeDetail({t}) {
    let scroll = Scroll.animateScroll;
    const { setValues, data } = useData();
    const [ startDateArray, setStartDateArray ] = useState(data.dateTimeGp?data.dateTimeGp.map(dateTime=>(dateTime.startDate)):[]);
    const [ endDateArray, setEndDateArray ] = useState(data.dateTimeGp?data.dateTimeGp.map(dateTime=>(dateTime.endDate)):[]);
    const [ dateChange, setDateChange ] = useState(0);
    const [ weekdayAvailable, setWeekdayAvailable ] = useState([]);
    const [ selectedTime, setSelectedTime ] = useState("00:00");
    const history = useHistory();
    let maxStartDate = new Date();
    maxStartDate = maxStartDate.setFullYear(maxStartDate.getFullYear() + 1)

    checkIfRedirect(data, history);

    // Validation for date time
    const schema = yup.object().shape({
        dateTimeGp: yup.array().of(
            yup.object().shape({
                startDate: yup.date()
                    .typeError(t("errors.frontend.790-E-0301"))
                    .min(new Date(new Date().setHours(0,0,0,0)), t("errors.frontend.790-E-0315"))
                    .max(new Date(maxStartDate), t("errors.frontend.790-E-0302"))
                    .test("correct date format", t("errors.frontend.790-E-0313"), (startDate)=>{
                        const startDateMoment = moment(startDate, "YYYY-MM-DD");
                        return moment(startDate, "YYYY-MM-DD").isValid();
                    }),
                endDate: yup.date()
                    .min(yup.ref('startDate'), t("errors.frontend.790-E-0303"))
                    .typeError(t("errors.frontend.790-E-0304"))
                    .test('within-1-year', t("errors.frontend.790-E-0305"), function(value) {
                        const { startDate } = this.parent;
                        let maxEndDate = new Date(startDate);

                        maxEndDate.setFullYear(maxEndDate.getFullYear()+1);
                        return moment(value).isSameOrBefore(maxEndDate)
                    })
                    .test("correct date format", t("errors.frontend.790-E-03143"), (endDate)=>{
                        const endDateMoment = moment(endDate, "YYYY-MM-DD");
                        return moment(endDate, "YYYY-MM-DD").isValid();
                    }),
                startTime: yup.string().required(t("errors.frontend.790-E-0306"))
                    .test("is-4-digits", t("errors.frontend.790-E-0316"), function(value) {
                        return !(value.includes('_'));
                    })
                    .min(5, t("errors.frontend.790-E-0307")),
                endTime: yup.string()
                    .required(t("errors.frontend.790-E-0308"))
                    .nullable(t("errors.frontend.790-E-0309"))
                    .test("is-greater", t("errors.frontend.790-E-0310"), function(value) {
                        const { startTime } = this.parent;
                        return moment(value, "HH:mm").isSameOrAfter(moment(startTime, "HH:mm"));
                    })
                    .test("is-4-digits", t("errors.frontend.790-E-0317"), function(value) {
                        return !(value.includes('_'));
                    })
                    .min(5, t("errors.frontend.790-E-0312")),
                recurrence: yup.array().test('has-object-selected', t("errors.frontend.790-E-0311"), (arr) => arr.some((obj) => obj.selected))
            })
        )
    })

    const recurrenceOpt = [
        {
            id: 'sunday',
            name: 'step3.dateTime.sunday'
        },
        {
            id: 'monday',
            name: 'step3.dateTime.monday'
        },
        {
            id: 'tuesday',
            name: 'step3.dateTime.tuesday'
        },
        {
            id: 'wednesday',
            name: 'step3.dateTime.wednesday'
        },
        {
            id: 'thursday',
            name: 'step3.dateTime.thursday'
        },
        {
            id: 'friday',
            name: 'step3.dateTime.friday'
        },
        {
            id: 'saturday',
            name: 'step3.dateTime.saturday'
        },
        {
            id: 'excludeHoliday',
            name: 'step3.dateTime.excludeHoliday'
        },
    ]

    const {
        register,
        handleSubmit,
        control,
        errors,
        clearErrors,
        watch,
        reset,
        getValues,
        setValue
    } = useForm({
        defaultValues: {
            dateTimeGp: (!data.dateTimeGp||data.dateTimeGp.length<1) ?
            (
                [{
                    startDate: '',
                    endDate: '',
                    startTime: '',
                    endTime: '',
                    recurrence:
                        recurrenceOpt.map((recurrence) => {
                            return {
                                id: recurrence.id,
                                name: recurrence.name,
                                selected: false
                            }
                        })
                }]
            ) :
            (
                data.dateTimeGp.map((obj) => {
                    return {
                        startDate: moment(obj.startDate).format("YYYY-MM-DD"),
                        endDate: moment(obj.endDate).format("YYYY-MM-DD"),
                        startTime: obj.startTime,
                        endTime: obj.endTime,
                        recurrence:
                            obj.recurrence.map((recurrence) => {
                                if (recurrence.selected) {
                                    return (
                                        {
                                            id: recurrence.id,
                                            name: recurrence.name,
                                            selected: true
                                        }
                                    )
                                } else {
                                    return (
                                        {
                                            id: recurrence.id,
                                            name: recurrence.name,
                                            selected: false
                                        }
                                    )
                                }
                            })
                    }
                })
            )
        },
        mode: "onSubmit",
        resolver: useYupValidationResolver(schema),
    });

    const dateTimeGpWatch = watch("dateTimeGp");

    const { fields, append, remove } = useFieldArray(
        {
            control,
            name: 'dateTimeGp',
        }
    );

    const handleAddDateTime = () => {
        if (dateTimeGpWatch.length >= 10) return;

        append({
            startDate: '',
            endDate: '',
            startTime: '00:00',
            endTime: '00:00',
            recurrence:
                recurrenceOpt.map((recurrence) => {
                    return {
                        id: recurrence.id,
                        name: recurrence.name,
                        selected: false
                    }
                })
        })
    }

    const onSubmit = (data) => {
    	clearErrors();
        console.log(data);
        setValues(data);
        history.push(`${process.env.REACT_APP_SUB_ROUTE}/vehicleDetail`);
    };

    const onError = (errors) => {
        scroll.scrollToTop();
    }

    useEffect(() => {
        let tempWeekdayAvailable = [];
        startDateArray.forEach((startDate, dateIndex) => {
            if(endDateArray[dateIndex]){
                if(Math.floor((endDateArray[dateIndex]-startDate)/(1000*60*60*24))<6){
                    const startDay = startDate.getDay();
                    const endDay = endDateArray[dateIndex].getDay();
                    if(startDay===endDay){
                        tempWeekdayAvailable[dateIndex] = {startWeekday: startDay, endWeekday: endDay, holidayDisabled:true};
                    } else{
                        tempWeekdayAvailable[dateIndex] = {startWeekday: startDay, endWeekday: endDay, holidayDisabled:false};
                    }
                }else{
                    tempWeekdayAvailable[dateIndex] = null;
                }
            }
        });
        setWeekdayAvailable(tempWeekdayAvailable);
    }, [dateChange]);

    useEffect(() => {
        scroll.scrollToTop();
    }, []);

    const handleStartDateChange = (index, startDate) => {
        let tempStartDateArray = startDateArray;
        tempStartDateArray[index] = startDate;
        setStartDateArray(tempStartDateArray);
        setDateChange(dateChange+1);
    }

    const handleEndDateChange = (index, endDate) => {
        let tempEndDateArray = endDateArray;
        tempEndDateArray[index] = endDate;
        setEndDateArray(tempEndDateArray);
        setDateChange(dateChange+1);
    }

    const handleReset = () => {
        console.log(getValues())
        scroll.scrollToTop();
		clearErrors();
        reset({
            dateTimeGp: [{
                startDate: '',
                endDate: '',
                startTime: '00:00',
                endTime: '00:00',
                recurrence:
                    recurrenceOpt.map((recurrence) => {
                        return {
                            id: recurrence.id,
                            name: recurrence.name,
                            selected: false
                        }
                    })
            }]
        })
        setValues({dateTimeGp: []});
        setStartDateArray([]);
        setEndDateArray([]);
        setDateChange(dateChange+1);
    }

    const handleBack = () => {
        // history.push("./vehicleDetail");
        history.push(`${process.env.REACT_APP_SUB_ROUTE}/personalInfo`);
    }

    const isEverydayDisable = (index) => {
        if(isEmpty(weekdayAvailable[index])){
            return false
        } else {
            return Math.abs(weekdayAvailable[index].endWeekday-weekdayAvailable[index].startWeekday)<6
        }
    }
    
    const isEverydayChecked = (index) => {
        return !watch(`dateTimeGp[${index}].recurrence`).slice(0,7).some((recurrence)=>(!recurrence.selected))
    }

    const handleEverydayChecked = (value, index) => {
        let targetArr = recurrenceOpt.map((recurrence) => {
            return {
                id: recurrence.id,
                name: recurrence.name,
                selected: !!value
            }
        });
        targetArr[7] = watch(`dateTimeGp[${index}].recurrence[7]`);
        setValue(`dateTimeGp[${index}].recurrence`, targetArr);
    }

    const isIE = /*@cc_on!@*/false || !!document.documentMode;

    console.log('data', data)
    console.log("form values", getValues())
    console.log("form errors", errors)
    console.log("watch: ", watch())
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-004'}</title>
            </Helmet>
            <Box className="wrapper dateTime">
                <Header langLock="langLocked" />
                <Box className="mainWrapper">
                    <Navbar step="step3" />
                    <Box className="contentWrapper">
                        <ErrorsContainer errors={errors} />
                        <StepHeader
                            step="common.step3"
                            title="step3.dateTimeTitle"
                            mandatory
                        />
                        <form
                            onSubmit={handleSubmit(onSubmit, onError)}
                            onReset={handleReset}
                            noValidate
                        >
                            <FormBox header="step3.dateTime.title">
                                { fields.map((item, index) => {
                                    return (
                                        <Box
                                            p={5}
                                            mb={5}
                                            bgcolor={index%2 === 0 ? 'repeatInput.main' : 'repeatInput.secondary'}
                                            key={item.id}
                                        >
                                            <Box
                                                mb={6}
                                                className="dateTimeWrapper"
                                            >

                                                {/* <FormLabel component="legend" className='dateTimeCs'>
                                                    <div>
                                                        {t('step3.dateTime.startDate')} <Box component="span" className="danger dateTimeCs">*</Box>
                                                    </div> */}
                                                    {/* Make Datepicker fields to be read only */}
                                                    {/* <DatePicker
                                                        id={`dateTimeGp[${index}].startDate`}
                                                        name={`dateTimeGp[${index}].startDate`}
                                                        ref={register()}
                                                        disablePast={true}
                                                        label={
                                                            <>
                                                                {t('step3.dateTime.startDate')} <Box component="span" className="danger">*</Box>
                                                            </>
                                                        }
                                                        KeyboardButtonProps={{
                                                            "aria-label": "startDate",
                                                        }}
                                                        inputProps={{
                                                            readOnly: true,
                                                            "aria-label": "startDate",
                                                        }}
                                                        error={!!errors["dateTimeGp["+index+"].startDate"]}
                                                        value={item.startDate}
                                                        onChange={handleStartDateChange.bind(this, index)}
                                                    /> */}
                                                    <Controller 
                                                        control={control}
                                                        id={`dateTimeGp[${index}].startDate`}
                                                        name={`dateTimeGp[${index}].startDate`}
                                                        render={(props)=>(
                                                            <InputMask mask="9999-99-99" value={props.value} onChange={(e)=>{
                                                                props.onChange(e);
                                                                    handleStartDateChange(index, new Date(e.target.value))
                                                                }}
                                                                beforeMaskedValueChange={dateMask}
                                                            >
                                                                {(inputProps) => (<TextField                                                    
                                                                    className={"startDateSelect" + ((!!errors["dateTimeGp[" + index + "].endDate"] && !(!!errors["dateTimeGp[" + index + "].startDate"])) ? " startDateError" : "")}
                                                                    label={<>{t('step3.dateTime.startDate')}<Box component="span" className="danger">*</Box>
                                                                    {!!errors["dateTimeGp["+index+"].startDate"] ? <img id={"dateTimeGp["+index+"].startDate"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                                    </>}
                                                                    type="text"
                                                                    id={`dateTimeGp[${index}].startDate`}
                                                                    name={`dateTimeGp[${index}].startDate`}
                                                                    placeholder={t("step3.dateTime.datePlaceholder")}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                    error={errors["dateTimeGp["+index+"].startDate"]}
                                                                    fullWidth
                                                                    {...inputProps}
                                                                />)}
                                                            </InputMask>
                                                    )}/>

                                                    {/* </FormLabel> */}
                                                {/* <FormLabel component="legend" className='dateTimeCs'>
                                                    <div>
                                                        {t('step3.dateTime.endDate')} <Box component="span" className="danger dateTimeCs">*</Box>
                                                    </div> */}
                                                    {/* <DatePicker
                                                        id={`dateTimeGp[${index}].endDate`}
                                                        name={`dateTimeGp[${index}].endDate`}
                                                        ref={register()}
                                                        disablePast={true}
                                                        label={
                                                            <>
                                                                {t('step3.dateTime.endDate')} <Box component="span" className="danger">*</Box>
                                                            </>
                                                        }
                                                        KeyboardButtonProps={{
                                                            "aria-label": "endDate",
                                                        }}
                                                        inputProps={{
                                                            readOnly: true,
                                                            "aria-label": "endDate",
                                                        }}
                                                        error={!!errors["dateTimeGp["+index+"].endDate"]}
                                                        value={item.endDate}
                                                        onChange={handleEndDateChange.bind(this, index)}
                                                    /> */}
                                                    <Controller 
                                                        control={control}
                                                        name={`dateTimeGp[${index}].endDate`}
                                                        render={(props)=>(
                                                            <InputMask mask="9999-99-99" value={props.value} onChange={(e)=>{
                                                                props.onChange(e);
                                                                    handleEndDateChange(index, new Date(e.target.value))
                                                                }}
                                                                beforeMaskedValueChange={dateMask}
                                                            >
                                                                {(inputProps) => (<TextField
                                                                    id={`dateTimeGp[${index}].endDate`}
                                                                    name={`dateTimeGp[${index}].endDate`}
                                                                    className={((!!errors["dateTimeGp[" + index + "].startDate"]) && !!!errors["dateTimeGp[" + index + "].endDate"] ? " endDateError" : "")}
                                                                    label={<>{t('step3.dateTime.endDate')} <Box component="span" className="danger">*</Box>
                                                                    {!!errors["dateTimeGp["+index+"].endDate"] ? <img id={"dateTimeGp["+index+"].endDate"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                                </>}
                                                                    defaultValue={isEmpty(item.endDate)?'':moment(item.endDate).format("YYYY-MM-DD")}
                                                                    placeholder={t("step3.dateTime.datePlaceholder")}
                                                                    InputLabelProps={{
                                                                        shrink: true
                                                                    }}
                                                                    InputProps={inputProps}
                                                                    error={errors["dateTimeGp["+index+"].endDate"]}
                                                                    fullWidth
                                                                />)}
                                                            </InputMask>
                                                    )}/>
                                                    		{/* </FormLabel> */}
                                            </Box>
                                            <Box
                                                mb={6}
                                                className="dateTimeWrapper"
                                            >
                                                {/* <FormControl
                                                    className="startTime"
                                                    error={
                                                        !!errors["dateTimeGp["+index+"].startTime"]
                                                    }
                                                >
                                                    <InputLabel
                                                        shrink
                                                        htmlFor={`dateTimeGp[${index}].startTime`}
                                                    >
                                                        {t('step3.dateTime.startTime')} <Box component="span" className="danger">*</Box>
                                                        {!!errors["dateTimeGp["+index+"].startTime"] ? <img id={"dateTimeGp["+index+"].startTime"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                    </InputLabel>
                                                    <div className="startTimeField">
                                                        <Controller
                                                            control={control}
                                                            name={`dateTimeGp[${index}].startTime`}
                                                            defaultValue={`${item.startTime}`}
                                                            render={(props)=>{
                                                                console.log("props: ", props);
                                                                console.log("props.value in moment: ", moment(props.value, "HH:mm"))
                                                                return (
                                                                    <TimePicker 
                                                                        id={`dateTimeGp[${index}].startTime`}
                                                                        onChange={( time, timeString ) =>{
                                                                            props.onChange(time.format("HH:mm"));
                                                                        }}
                                                                        onSelect={(value) => {
                                                                            const timeString = moment(value).format("HH:mm");
                                                                            props.onChange(timeString);
                                                                        }} 
                                                                        use12Hours
                                                                        inputReadOnly={true}
                                                                        showNow={false}
                                                                        minuteStep={5}
                                                                        format='hh:mm A'
                                                                        placeholder=""
                                                                        suffixIcon={<ScheduleOutlinedIcon />}
                                                                        value={moment(props.value, "HH:mm")}
                                                                    />
                                                                )
                                                            }} 
                                                        />
                                                    </div>
                                                    <FormHelperText>
                                                        {errors["dateTimeGp["+index+"].startTime"]?.message}
                                                    </FormHelperText>
                                                </FormControl> */}
                                                <Controller 
                                                        control={control}
                                                        name={`dateTimeGp[${index}].startTime`}
                                                        render={(props)=>{
                                                            return <InputMask mask="99:99" value={props.value} onChange={(e)=>{
                                                                    props.onChange(e);
                                                                }}
                                                                beforeMaskedValueChange={timeMask}
                                                            >
                                                                {(inputProps) => {
                                                                    return <TextField
                                                                            id={`dateTimeGp[${index}].startTime`}
                                                                            name={`dateTimeGp[${index}].startTime`}
                                                                            className={((!!errors["dateTimeGp[" + index + "].endTime"]) && !!!errors["dateTimeGp[" + index + "].startTime"] ? " startTimeError" : "")}
                                                                            label={<>{t('step3.dateTime.startTime')} <Box component="span" className="danger">*</Box>
                                                                            {!!errors["dateTimeGp["+index+"].startTime"] ? <img className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}</>}
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            InputProps={inputProps}
                                                                            error={errors["dateTimeGp["+index+"].startTime"]}
                                                                            placeholder={t("step3.dateTime.timePlaceholder")}
                                                                            fullWidth
                                                                    />
                                                        }}
                                                            </InputMask>
                                                        }}
                                                    />
                                                    {/* <FormControl
                                                      className="endTime"
                                                      error={
                                                        !!errors["dateTimeGp["+index+"].endTime"]
                                                      }
                                                    >
                                                      <InputLabel
                                                        shrink
                                                        htmlFor={`dateTimeGp[${index}].endTime`}
                                                      >
                                                        {t('step3.dateTime.endTime')} <Box component="span" className="danger">*</Box>
                                                        {!!errors["dateTimeGp["+index+"].endTime"] ? <img id={"dateTimeGp["+index+"].endTime"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                      </InputLabel>
                                                      <div className="endTimeField">
                                                          <Controller
                                                              control={control}
                                                              name={`dateTimeGp[${index}].endTime`}
                                                              defaultValue={`${item.endTime}`}
                                                              render={(props)=>{
                                                                  console.log("props: ", props);
                                                                  return (
                                                                      <TimePicker 
                                                                          id={`dateTimeGp[${index}].endTime`}
                                                                          onChange={( time, timeString ) =>{
                                                                              props.onChange(time.format("HH:mm"));
                                                                          }}
                                                                          onSelect={(value) => {
                                                                              const timeString = moment(value).format("HH:mm");
                                                                              props.onChange(timeString);
                                                                          }} 
                                                                          use12Hours
                                                                          inputReadOnly={true}
                                                                          showNow={false}
                                                                          minuteStep={5}
                                                                          format='hh:mm A'
                                                                          placeholder=""
                                                                          suffixIcon={<ScheduleOutlinedIcon />}
                                                                          value={moment(props.value, "HH:mm")}
                                                                      />
                                                                  )
                                                              }} 
                                                          />
                                                      </div>
                                                      <FormHelperText>
                                                        {errors["dateTimeGp["+index+"].endTime"]?.message}
                                                      </FormHelperText>
                                                    </FormControl> */}
                                                     <Controller 
                                                        control={control}
                                                        name={`dateTimeGp[${index}].endTime`}
                                                        render={(props)=>{
                                                            return <InputMask mask="99:99" value={props.value} onChange={(e)=>{
                                                                    props.onChange(e);
                                                                }}
                                                                beforeMaskedValueChange={timeMask}
                                                            >
                                                                {(inputProps) => {
                                                                    return <TextField
                                                                        id={`dateTimeGp[${index}].endTime`}
                                                                        name={`dateTimeGp[${index}].endTime`}
                                                                        className={((!!errors["dateTimeGp[" + index + "].startTime"]) && !!!errors["dateTimeGp[" + index + "].endTime"] ? " endTimeError" : "")}
                                                                        label={<>{t('step3.dateTime.endTime')}<Box component="span" className="danger">*</Box>
                                                                        {!!errors["dateTimeGp["+index+"].endTime"] ? <img className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}</>}
                                                                        inputProps={{
                                                                            min:isObjectEmpty(watch(`dateTimeGp[${index}].startTime`))?"00:00":watch(`dateTimeGp[${index}].startTime`)
                                                                        }}
                                                                        InputLabelProps={{
                                                                            shrink: true,
                                                                        }}
                                                                        InputProps={inputProps}
                                                                        error={errors["dateTimeGp["+index+"].endTime"]}
                                                                        placeholder={t("step3.dateTime.timePlaceholder")}
                                                                        fullWidth
                                                                    />
                                                                }}
                                                            </InputMask>
                                                        }}
                                                    />
                                            </Box>
                                            <Box mb={6}>
                                                <FormControl
                                                    component="fieldset"
                                                    error={!!errors["dateTimeGp["+index+"].recurrence"]}
                                                >
                                                    <FormLabel component="legend">
                                                        <Box mb={3}>
                                                            {t('step3.dateTime.recurrence')} <Box component="span" className="danger">*</Box>
                                                            {!!errors["dateTimeGp["+index+"].recurrence"] ? <img id={"dateTimeGp["+index+"].recurrence"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                        </Box>
                                                        <Box>
                                                            {t('step3.dateTime.recurrenceNote')}
                                                        </Box>
                                                    </FormLabel>
                                                    <FormGroup className="recurrence">
                                                        <Box>
                                                            <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    name="everyday"
                                                                    checked={isEverydayDisable(index)?false:isEverydayChecked(index)}
                                                                    color="primary"
                                                                    onChange={(e)=>handleEverydayChecked(e.target.checked, index)}
                                                                    disabled={isEverydayDisable(index)}
                                                                />
                                                            }
                                                            label={t('step3.dateTime.everyday')}
                                                            />
                                                        </Box>
                                                        {(item.recurrence || []).map((week, j) => {
                                                            let disabled = false;
                                                            if(j!=7){
                                                                if(weekdayAvailable[index]){
                                                                    if(weekdayAvailable[index].endWeekday>=weekdayAvailable[index].startWeekday){
                                                                        disabled = j<weekdayAvailable[index].startWeekday||j>weekdayAvailable[index].endWeekday;
                                                                    }else{
                                                                        disabled = j<weekdayAvailable[index].startWeekday&&j>weekdayAvailable[index].endWeekday;
                                                                    }
                                                                }
                                                            } else {
                                                                if(weekdayAvailable[index]?.holidayDisabled){
                                                                    disabled = true;
                                                                }
                                                            }
                                                            return (
                                                                <Box key={week.id}>
                                                                    <Controller
                                                                        as={<input />}
                                                                        control={control}
                                                                        type="hidden"
                                                                        name={`dateTimeGp[${index}].recurrence[${j}].id`}
                                                                        defaultValue={week.id}
                                                                    />
                                                                    <Controller
                                                                        as={<input />}
                                                                        control={control}
                                                                        type="hidden"
                                                                        name={`dateTimeGp[${index}].recurrence[${j}].name`}
                                                                        defaultValue={week.name}
                                                                    />
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Controller
                                                                                control={control}
                                                                                id={`dateTimeGp[${index}].recurrence[${j}].id`}
                                                                                name={`dateTimeGp[${index}].recurrence[${j}].selected`}
                                                                                // defaultValue={false}
                                                                                render={(props) => {
                                                                                    if(disabled&&props.value){
                                                                                        props.onChange(false)
                                                                                    }
                                                                                    return <Checkbox
                                                                                        checked={disabled?false:props.value}
                                                                                        color="primary"
                                                                                        onChange={(e) => props.onChange(e.target.checked)}
                                                                                        disabled={disabled}
                                                                                    />
                                                                                }}
                                                                                defaultValue={week.selected}
                                                                                error={!!errors["dateTimeGp["+index+"].recurrence["+j+"].selected"]}
                                                                            />
                                                                        }
                                                                        label={t(week.name)}
                                                                        disabled={disabled}
                                                                    />
                                                                </Box>
                                                            )
                                                        })}
                                                    </FormGroup>
                                                </FormControl>
                                            </Box>
                                            {
                                                dateTimeGpWatch.length > 1 &&
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className="removeBtn"
                                                    onClick={() => {
                                                        remove(index);
                                                        let tempStartDateArray = startDateArray;
                                                        let tempEndDateArray = endDateArray;
                                                        if(tempStartDateArray[index]){
                                                            tempStartDateArray.splice(index, 1)
                                                            setStartDateArray(tempStartDateArray);
                                                            setDateChange(dateChange+1);
                                                        }
                                                        if(tempEndDateArray[index]){
                                                            tempEndDateArray.splice(index, 1);
                                                            setEndDateArray(tempEndDateArray);
                                                            setDateChange(dateChange+1);
                                                        }
                                                    }}
                                                >
                                                    {t('common.button.remove')}
                                                </Button>
                                            }
                                        </Box>
                                    );
                                })}
                                {
                                    dateTimeGpWatch.length < 10 &&
                                        <Box
                                            p={5}
                                        >
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleAddDateTime}
                                            >
                                                {t('step3.dateTime.addDateTime')}
                                            </Button>
                                            {t("step3.dateTime.addDateTimeIfNeed", "*Add date and time if you need")}
                                        </Box>
                                }
                            </FormBox>
                            <FormBox>
                                <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                >
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        className="secBtn"
                                        onClick={handleBack}
                                    >
                                        {t('common.button.back')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        type="reset"
                                        className="secBtn"
                                    >
                                        {t('common.button.clear')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        {t('common.button.next')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </main>
    )
})
